import { addDoc, collection, serverTimestamp, } from "firebase/firestore";
import { prepareForFirestore } from "./utils";
const auditLogConverter = {
    toFirestore(value) {
        return {
            ...prepareForFirestore(value),
            createdAt: serverTimestamp(),
        };
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return {
            id: snapshot.id,
            path: snapshot.ref.path,
            ...data,
            timestamp: data.timestamp?.toDate() || data.timestamp,
        };
    },
};
export function auditLogsCollection(db) {
    return collection(db, "auditLogs").withConverter(auditLogConverter);
}
export async function logAction(db, params) {
    return addDoc(auditLogsCollection(db), {
        ...params,
        timestamp: new Date(),
    });
}
